import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { DashlineSeparator } from './styledElements';
import OfferTutorialSlider from './offerTutorial/OfferTutorialSlider';
import { useJoin } from '../../contexts/JoinContext';
import { EVENT_NAMES } from '../../constants/mixpanel';
import { Profile, ProfileMaker } from '../../models/Profile';
import { mixpanelTrackOnboardingCompleted } from '../../utils/mixpanel/onboardingCompleted';
import { RootState } from '../../store';
import { mixpanelTrackEvent } from '../../utils/mixpanel/common';
import { getTutorialData } from '../../modules/QuickOfferModal/TutorialData';
import {
  refreshProfile,
  setShowSelfieVerificationWall,
  updateProfileLivenessStatus,
} from '../../actions/profileActions';
import { clearErrors, killLoading } from '../../actions/commonActions';
import { removeLocalItem } from '../../common';
import { ACCOUNT_TYPE_SUCCESSFUL_USER } from './constants';
import { NewCreditOfferVariations } from '../../constants/evidently';
import useMixPanel from '../../hooks/useMixPanel';

interface Props {
  ownProfile: Profile;
}

const JoinOfferTutorial: React.FC<Props> = ({ ownProfile }: Props) => {
  const { convertToFormData, updateOfferTutorialState, uploadedPhoto, skippedStepCounter, stepsFormData, setSVStatus } =
    useJoin();

  const dispatch = useDispatch();
  const isAttractiveUser = ownProfile.isAttractive();
  const { setMixpanelDataByKeyHandler } = useMixPanel();
  const newCreditOfferVariation = 'IntroCreditOffer' as NewCreditOfferVariations;
  const { startSelfieVerification } = useSelector((state: RootState) => state.profile);

  const redirectUserAfterUpdate = ({ accountType }: { accountType: 1 | 2 }) => {
    if (
      typeof newCreditOfferVariation !== 'undefined' &&
      newCreditOfferVariation &&
      newCreditOfferVariation === 'IntroCreditOffer' &&
      accountType === ACCOUNT_TYPE_SUCCESSFUL_USER
    ) {
      // set mixpanel source value credit purchased
      setMixpanelDataByKeyHandler({
        key: EVENT_NAMES.CREDITS_PURCHASED,
        payload: {
          Source: 'After Reg Popup',
        },
      });
      window.location.href = '/packages?userFirstTimeLogin=1';
    } else {
      window.location.href = '/search?userFirstTimeLogin=1';
    }
  };

  const submit = () => {
    try {
      const formData = convertToFormData(false);

      //refresh profile, remove localstoage keys, redirection logic -> redirect to respective page after registeration
      dispatch(refreshProfile()).then(response => {
        dispatch(clearErrors());
        // unset user-defined localStorages after successful signup
        sessionStorage.removeItem('quickOfferSubmitted');
        sessionStorage.removeItem('onboarding');
        removeLocalItem('pupil');
        removeLocalItem('ref');
        removeLocalItem('join_predata');
        removeLocalItem('join_onboarding_predata');
        removeLocalItem('onboarding_skip_modal');
        dispatch(killLoading());

        //call mixpanel events
        if (response?.hash_id && response.is_mixpanel_eligible_and_enabled) {
          mixpanelTrackEvent({
            eventName: EVENT_NAMES.OFFER_TUTORIAL_STEP_COMPLETED,
            payload: {
              eventProperties: {
                Result: 'Completed',
                'Number of photos added': uploadedPhoto?.length ?? 0,
                'Hash Id': response.hash_id,
              },
            },
          });

          mixpanelTrackOnboardingCompleted({
            skippedStep: skippedStepCounter
              ? Object.values(skippedStepCounter).filter(value => value === true).length
              : 0,
            formData: stepsFormData,
          });
        }

        return redirectUserAfterUpdate({
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          accountType: parseInt(formData instanceof FormData ? formData.get('account_type') : formData.account_type),
        });
      });
    } catch (error) {
      console.warn('error', error);
    }
  };

  const handleOnClose = () => {
    submit();
    updateOfferTutorialState();

    if (startSelfieVerification) {
      dispatch(setShowSelfieVerificationWall(false));
      dispatch(updateProfileLivenessStatus());
      setSVStatus('done');
    }
  };

  const customStyle = { height: 88, width: 94 };

  const tutorialData = getTutorialData(isAttractiveUser, customStyle, true);

  return (
    <div>
      <DashlineSeparator />
      <OfferTutorialSlider
        slidesData={tutorialData}
        clickableIndicators={true}
        onClose={handleOnClose}
        customButtonContainerStyle={undefined}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    ownProfile: ProfileMaker.create(state.profile.profile),
  };
};

export default connect(mapStateToProps, {})(JoinOfferTutorial);
